import React, { Component } from 'react'

import { isMobile } from '../../utils/deviceInfo'
import './trivia-survey.css'
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Tooltip,
  ButtonDropdown,
  UncontrolledButtonDropdown,
} from 'reactstrap'
import { connect } from 'react-redux'
import moment from 'moment'

import axios from '../../axios'
import * as url from '../../utils/url'
import * as actionCreators from '../../modules/actions/index'
import Loading from '../../hoc/Loading/Loading'
import { AiFillCloseCircle } from 'react-icons/ai'
import { MdFileUpload, MdOutlineMobileFriendly } from 'react-icons/md'
import { FaArrowRight, FaList } from 'react-icons/fa6'
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
} from '../../components/TableComponents/RowCardShadow/RowCardShadow'

import ReactTooltip from 'react-tooltip'
import { ImFontSize } from 'react-icons/im'
import { GiGears, GiOpenTreasureChest } from 'react-icons/gi'
import { MdOutlineQuiz } from 'react-icons/md'
import {
  BsAlarmFill,
  BsBrush,
  BsCheckLg,
  BsDownload,
  BsFillEyeFill,
  BsFillGearFill,
  BsThreeDots,
} from 'react-icons/bs'
import TriviaEditViewListUI from './Components/TriviaEditViewListUI'
import {
  formatQuestionsNumberWise,
  TRIVIA_DESCRIPTION,
} from '../../utils/constants'
import ShareTriviaComponent from './Components/ShareTriviaComponent'
import debounce from 'lodash.debounce'
import TriviaResultsComponent from './Components/TriviaResultsSection'
import LinkTriviaRewardPopup from './Components/LinkTriviaRewardPopup'
import { publishDisabled, THEME_SETTING } from './data'
import AdvanceTrivvySettingModal from './Components/AdvanceTrivvySettingModal'
import parse from 'html-react-parser'
import RangeInput from '../../components/RangeInput/RangeInput'
import Select from 'react-select/lib/Select'
import { toastContainer, dismissToast } from '../../utils/toast'
import { BiEdit } from 'react-icons/bi'
import QuestionsListModal from './Components/QuestionsListModal'
import NewShareTriviaComponent from './Components/ShareTrivia/NewShareTriviaComponent'
import ManualRemindersModal from './Components/ManualRemindersModal'

class TriviaEdit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      surveyItem: null,
      menu: null,
      isPreview: false,

      linkedRewards: [],
      linkPopup: false,
      linkedRewards: [],

      advanceSettingsModal: false,
      buttonDrodownOpen: false,
      questionsListModal: false,
      manualReminderModal: false,
    }
  }

  retrieveSearchPath = () => {
    const section = this.props.match.params.tab
    if (!section) {
      this.setState({ menu: 1 })
      this.props.history.push('edit')
    } else {
      if (section === 'edit') {
        this.setState({ menu: 1 })
      }
      if (section === 'share') {
        this.setState({ menu: 2 })
      }
      if (section === 'results') {
        this.setState({ menu: 3 })
      }
      if (section === 'results-summary') {
        this.setState({ menu: 3 })
      }
      if (section === 'results-responses') {
        this.setState({ menu: 3 })
      }
    }
  }

  openQuestionsList = () => {
    this.setState({ questionsListModal: true })
  }

  closeQuestionsList = () => {
    this.setState({ questionsListModal: false })
  }

  publishTriviaApiCall = (value, cb = null) => {
    const updateData = {
      isPublished: value,
    }

    if (
      moment(this.props.currentTrivia.trivvyEndDate).isSameOrBefore(
        moment(),
        'day'
      ) &&
      value == true
    ) {
      updateData.trivvyEndDate = null
    }
    axios
      .put(url.updateTrivvyPublish(this.props.currentTrivia._id), {
        updateData: updateData,
      })
      .then(({ data }) => {
        this.props.setCurrentTrivia({
          ...this.props.currentTrivia,
          isPublished: value,
          publishedDate: data.data.trivia.publishedDate,
          unpublishedDate: data.data.trivia.unpublishedDate,
          trivvyEndDate: data.data.trivia.trivvyEndDate,
        })

        if (cb) {
          cb()
        }

        if (value == true) {
          dismissToast()
        }
      })
      .catch((err) => {
        console.log('pubErr', err)
        toastContainer('Error while updating trivvy publish status.', 'error')
      })
  }

  selectMenu = (menu) => {
    let menuText = ''
    if (menu === 1) {
      menuText = 'edit'
    }
    if (menu === 2) {
      menuText = 'share'
    }
    if (menu === 3) {
      this.getTrivvyForEditCall(true)
      menuText = 'results'
    }
    this.props.history.push(menuText)
    this.setState({ menu })
  }

  togglePreview = () => {
    this.props.history.push(
      `/home/trivia/${this.props.user.profile.organizationId._id}/preview-quiz/${this.state.surveyItem._id}/start`
    )
  }

  componentDidMount() {
    dismissToast()
    const paramsOrgId = this.props.match.params.orgId
    const userOrgId = this.props.user.profile.organizationId._id
    if (paramsOrgId == userOrgId && this.props.user.profile.role == 'Admin') {
    } else {
      toastContainer(
        'This content is not available to you. Please ask your admin or login as a different user to access it.',
        'error'
      )
      this.props.history.push(
        `/home/trivia/${this.props.user.profile.organizationId._id}/list`
      )
    }
    const surveyId = this.props.match.params.id
    this.retrieveSearchPath()
    // this.props.setCurrentQuiz(null);
    this.props.setCurrentQuestion(null)

    this.getTrivvyForEditCall(false)

    let orgId = this.props.user.profile.organizationId._id

    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data
      this.props.orgChangeSuccess(payload)
    })
  }

  getTrivvyForEditCall = (noLoad) => {
    const surveyId =
      typeof noLoad == 'string' ? noLoad : this.props.match.params.id
    axios
      .get(url.getTriviaForEdit(surveyId, noLoad))
      .then(({ data }) => {
        const survey_doc = {
          ...data.data.trivia,
          questions: formatQuestionsNumberWise(data.data.trivia.questions),
        }

        this.setState({
          surveyItem: survey_doc,
          linkedRewards: data.data.linkedRewards,
        })

        this.props.setCurrentTrivia(survey_doc)

        if (
          survey_doc &&
          !survey_doc.isMessaging &&
          survey_doc.isPublished != true
        ) {
          toastContainer(
            <div>
              {/* {publishDisabled(survey_doc).toString()} Ready to share your
              trivvy? Click{' '}
              <b
                onClick={() => {
                  this.publishTriviaApiCall(true, null)

                  this.selectMenu(2)
                }}>
                here
              </b>{' '}
              publish and then share it */}
              You can review and edit questions on the left-hand side or click{' '}
              <b
                onClick={() => {
                  this.publishTriviaApiCall(true, null)
                  this.selectMenu(2)
                }}>
                here
              </b>{' '}
              to publish and share your Trivvy.
            </div>,
            {
              background: 'rgb(238 250 236)',
              color: 'rgb(0, 83, 0)',
              fontSize: '15px',
              lineHeight: '1.85em',
              borderRadius: '0.5rem',
              boxShadow: 'rgb(38, 57, 70) 2px 14px 28px -6px',
              right: isMobile ? 0 : '85%',
              marginBottom: '0px',
            }
          )
        }

        const search = window.location.search
        const params = new URLSearchParams(search)
        const autoPub = params.get('autoPublish')
        if (autoPub == true || autoPub == 'true') {
          this.publishTriviaApiCall(true, null)
          // this.props.setCurrentTrivia({ ...survey_doc, isPublished: true });
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  componentWillUnmount() {
    dismissToast()
    // toastContainer.dismiss()
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.currentTrivia) !==
      JSON.stringify(nextProps.currentTrivia)
    ) {
      this.setState({
        surveyItem: nextProps.currentTrivia,
      })
    }

    if (nextProps.match.params.id != this.props.match.params.id) {
      this.getTrivvyForEditCall(nextProps.match.params.id)
    }
  }

  showPublishToast = () => {
    if (this.props.currentTrivia && this.props.currentTrivia.isMessaging) {
      return
    }
    toastContainer(
      <div>
        Ready to share your trivvy? Click{' '}
        <b
          onClick={() => {
            this.publishTriviaApiCall(true, null)

            this.selectMenu(2)
          }}>
          here
        </b>{' '}
        publish your trivvy & then share it
      </div>,
      // { background: "#eefaec", color: "#005300", fontSize: "14px" }
      {
        background: 'rgb(238 250 236)',
        color: 'rgb(0, 83, 0)',
        fontSize: '15px',
        lineHeight: '1.85em',
        borderRadius: '0.5rem',
        boxShadow: 'rgb(38, 57, 70) 2px 14px 28px -6px',
        right: '85%',
        marginBottom: '0px',
      }
    )
  }

  editSurveyName = (val) => {
    this.props.setCurrentTrivia({ ...this.props.currentTrivia, name: val })

    this.debounceAutoSaveData('name', val)
  }

  callApiToAutoSave = (key, data) => {
    const payload = {
      [key]: data,
    }

    const { currentTrivia } = this.props

    if (currentTrivia) {
      axios
        .put(url.editTrivia(currentTrivia._id), { updateData: payload })
        .then((res) => {
          console.log(res.data.data)
          if (payload.isPublished) {
            dismissToast()
          }
        })
        .catch((err) => console.log(err))
    }
  }

  debounceAutoSaveData = debounce(this.callApiToAutoSave, 3000)

  afterLink = () => {
    const surveyId = this.props.match.params.id
    this.retrieveSearchPath()
    // this.props.setCurrentQuiz(null);
    this.props.setCurrentQuestion(null)

    axios
      .get(url.getTriviaForEdit(surveyId, false))
      .then(({ data }) => {
        const survey_doc = {
          ...data.data.trivia,
          questions: formatQuestionsNumberWise(data.data.trivia.questions),
        }

        this.setState({
          surveyItem: survey_doc,
          linkedRewards: data.data.linkedRewards,
        })

        this.props.setCurrentTrivia(survey_doc)
      })
      .catch((err) => {
        console.log(err)
      })

    this.setState({ linkPopup: false })
  }

  menuNav = () => {
    let { currentTrivia } = this.props

    if (currentTrivia) {
      let endUrl = ''
      if (currentTrivia && currentTrivia.triviaCategoryType == 'REWARD') {
        endUrl = '/rewards'
      } else if (currentTrivia.isMessaging) {
        endUrl = '/messages'
      } else {
        endUrl = '/list'
      }
      let topMenuURL =
        '/home/trivia/' + this.props.user.profile.organizationId._id + endUrl

      console.log('topMenuURL ---', topMenuURL)

      return this.props.history.push(topMenuURL)
    }
  }

  exportConvoPDF = async () => {
    const { renderInPage } = this.props
    // console.log(this.state.exporting,document.querySelector("#jspdf_export_conversation"))
    // const pdf = new jsPDF("portrait", "pt", "a4");
    const data = await document.querySelector('#jspdf_export_trivvy')

    const pdf = window.html2pdf().from(data)

    // pdf.setFont("Arial", "normal");
    // pdf.setLanguage("mr")

    // pdf.html(data,{
    //   fontFaces:[
    //     {family:"Arial, Roboto, sans-serif"
    //   }]
    // })

    pdf.then(async () => {
      this.setState({ exporting: false })

      if (renderInPage) {
        // pdf.save(
        //   `${moment(new Date()).format(
        //     "dddd, MMMM Do YYYY, h:mm:ss a"
        //   )} - dani.pdf`
        // );
      } else {
        var string = await pdf.output('datauristring')
        console.log(string)
        var embed = "<embed width='100%' height='100%' src='" + string + "'/>"
        var x = window.open()
        x.document.open()
        x.document.write(embed)

        var a = document.createElement('A')
        var filePath = await pdf.output('datauristring')
        a.href = filePath
        a.download = `${moment(new Date()).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        )} - ${this.props.currentTrivia.name}-${
          this.props.currentTrivia.organizationId
        }-${this.props.currentTrivia._id}.pdf`
        document.body.appendChild(a)
        setTimeout(() => {
          a.click()
          document.body.removeChild(a)
          x.close()
        }, 700)
      }
    })
  }

  toggleButtonDropdown = () => {
    this.setState({
      buttonDrodownOpen: !this.state.buttonDrodownOpen,
    })
  }

  updateTrivvyLinkedRewards = (data) => {
    this.setState({
      linkedRewards: data,
    })
  }

  handleResendSMS = () => {
    axios
      .post(url.resendIsMessagingTrivvyToUsers, {
        triviaId: this.props.currentTrivia._id,
      })
      .then(({ data }) => {
        if (data.data.updateTrivvyUsers) {
          this.props.setCurrentTrivia({
            ...this.props.currentTrivia,
            sharedWithUsers: [...data.data.updateTrivvyUsers.sharedWithUsers],
          })
        }
        if (data.data.totalSent) {
          toastContainer('Resent text messages successfully', 'success')
        } else {
          toastContainer('Resent text messages successfully.', 'success')
        }
      })
      .catch((err) => {
        toastContainer('Error while resending', 'error')
      })
  }

  render() {
    const {
      surveyItem,
      menu,
      isPreview,

      linkPopup,
      linkedRewards,
      manualReminderModal,
      advanceSettingsModal,
      buttonDrodownOpen,
      fontsModalOpen,
      questionsListModal,
    } = this.state

    const { currentTrivia } = this.props

    let isEditable = currentTrivia && currentTrivia.isPublished
    let adminRestricted = false

    if (currentTrivia && currentTrivia.createdBy) {
      if (
        currentTrivia &&
        currentTrivia.createdBy._id != this.props.user.profile._id
      ) {
        if (!currentTrivia.isPublished) {
          isEditable = true
        }

        adminRestricted = true
      }

      if (
        this.props.user.profile.orgAdmin ||
        this.props.user.profile.role == 'Admin'
      ) {
        if (!currentTrivia.isPublished) {
          isEditable = false
        }
        adminRestricted = false
      }
    }

    const planType = this.props.user.profile.organizationId.trivvyPlanType

    let publishDisable = false
    let unPublishDisable = false
    let endDisable = false
    let buttonText = ''

    if (currentTrivia) {
      if (currentTrivia.isPublished) {
        publishDisable = true
      }

      if (!currentTrivia.isPublished) {
        unPublishDisable = true
      }

      if (currentTrivia.trivvyEndDate) {
        if (moment(currentTrivia.trivvyEndDate).isSameOrBefore(moment())) {
          endDisable = true
          publishDisable = false
          unPublishDisable = false
        }
      }

      if (
        currentTrivia.trivvyEndDate &&
        moment(currentTrivia.trivvyEndDate).isSameOrBefore(moment())
      ) {
        buttonText = 'Ended'
      } else if (currentTrivia.isPublished) {
        buttonText = 'Published'
      } else {
        buttonText = 'Unpublished'
      }
    }

    const isMessagingTrivvy = currentTrivia && currentTrivia.isMessaging

    const disabledResendButton = () => {
      if (
        currentTrivia &&
        currentTrivia.sharedWithUsers &&
        Array.isArray(currentTrivia.sharedWithUsers)
      ) {
        const notSentUser = currentTrivia.sharedWithUsers.find(
          (x) => x.mobileNumber && !x.smsDate
        )

        if (notSentUser) {
          return false
        }
      }

      return true
    }

    return (
      <div className="trivia_survey_edit_page">
        {linkPopup && currentTrivia ? (
          <LinkTriviaRewardPopup
            currentTrivia={currentTrivia}
            selectedItems={linkedRewards}
            open={linkPopup}
            onClose={() => this.setState({ linkPopup: false })}
            trivia={currentTrivia}
            setSelectedItems={this.updateTrivvyLinkedRewards}
          />
        ) : (
          ''
        )}
        <div
          className={`survey-top-div ${!isMobile && ''} ${
            isMessagingTrivvy ? 'messaging-bar' : ''
          }`}>
          {surveyItem && (
            <Row
              className={`survey_detail_page_top_navbar bg-white pl-2 mx-0 ${
                isMobile ? 'mx-0' : ''
              } ${!isMobile && 'pl-3'}`}>
              {currentTrivia && (
                <div
                  style={{
                    display: 'none',
                  }}>
                  <div
                    style={{
                      width: '700px',
                      marginLeft: '15px',
                      padding: '15px',
                    }}
                    id="jspdf_export_trivvy">
                    <div>
                      <h2 className="mt-2 text-center">{currentTrivia.name}</h2>

                      {/* <div className="text-center mt-2 mb-4">
                        ({currentTrivia.organizationId}-{currentTrivia._id})
                      </div> */}

                      <div>
                        {currentTrivia.questions &&
                          currentTrivia.questions.length &&
                          currentTrivia.questions.map((question, index) => {
                            return (
                              <div className="mt-3">
                                <h4>
                                  {index + 1}){parse(question.question_text)}
                                </h4>
                                {question.question_type == 'LINEAR_NUMERIC' && (
                                  <div className="my-2">
                                    {question.linearNumericConfigs &&
                                    question.linearNumericConfigs.min &&
                                    question.linearNumericConfigs.max ? (
                                      <span>
                                        Give answer in rage of{' '}
                                        {question.linearNumericConfigs.min} -{' '}
                                        {question.linearNumericConfigs.max}{' '}
                                      </span>
                                    ) : (
                                      ' Give answer'
                                    )}
                                  </div>
                                )}

                                {question.question_type === 'LINEAR_NUMERIC' ? (
                                  <div className="mt-3">
                                    <RangeInput
                                      min={question.linearNumericConfigs.min}
                                      max={question.linearNumericConfigs.max}
                                      value={null}
                                      onChange={(value) => {}}
                                      themeSettings={
                                        currentTrivia.themeSettings ||
                                        THEME_SETTING
                                      }
                                    />
                                  </div>
                                ) : question.question_type === 'TEXT' ? (
                                  <div className="mt-3">
                                    <Input type="textarea" rows={2} />
                                  </div>
                                ) : question.question_type === 'MCQ' ? (
                                  <div className="mt-3">
                                    <ol
                                      style={
                                        {
                                          // listStyle: "none",
                                        }
                                      }>
                                      {question.options &&
                                        question.options.length &&
                                        question.options.map((option, idx) => {
                                          return <li> {parse(option.text)} </li>
                                        })}
                                    </ol>
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <Col md={3} className={isMobile ? 'pl-4' : 'pl-0'}>
                <div className="pt-2 d-flex">
                  <span
                    className="survey_detail_page_top_wp"
                    onClick={() => this.menuNav()}
                    // data-tip={TRIVIA_DESCRIPTION}
                    data-for="trivvy_edit_title">
                    {isMessagingTrivvy ? 'Messages' : 'Trivvy'}
                    {/* My Workspace{" "} */}
                  </span>{' '}
                  {/* <ReactTooltip id="trivvy_edit_title" place="right" /> */}-
                  {currentTrivia && currentTrivia.isPublished ? (
                    <span className="ml-2 trivvy_title_ellipsis">
                      {surveyItem.name}
                    </span>
                  ) : currentTrivia && !currentTrivia.isPublished ? (
                    <input
                      value={surveyItem.name}
                      onChange={(e) => this.editSurveyName(e.target.value)}
                      className="survey_detail_page_top_name"
                      disabled={isEditable}
                      style={{
                        position: 'relative',
                        flex: 1,
                        color:
                          currentTrivia && currentTrivia.isPublished
                            ? '#262627'
                            : '',
                        borderColor:
                          currentTrivia && currentTrivia.isPublished
                            ? 'transparent'
                            : '',
                      }}
                    />
                  ) : (
                    ''
                  )}{' '}
                  {currentTrivia && currentTrivia.isPublished ? null : (
                    <small
                      data-for="trivvy_edit_title2"
                      data-tip="Edit trivvy title"
                      className="survey_detail_page_top_name_highlight">
                      Edit <BiEdit />
                    </small>
                  )}
                  <ReactTooltip id="trivvy_edit_title2" place="right" />
                </div>
              </Col>
              <Col
                md={6}
                className={`${
                  isMobile ? 'mt-4' : ''
                } d-flex justify-content-center`}>
                <ul className="data-user trivia-edit-top-nav-survey-ui">
                  {!isMessagingTrivvy && (
                    <li>
                      {' '}
                      <a
                        className={`${
                          menu == 1 ? 'profile_page_menu_option_active' : ''
                        }`}
                        onClick={() => this.selectMenu(1)}>
                        Edit
                      </a>{' '}
                    </li>
                  )}

                  <li>
                    <a
                      className={`${
                        menu == 2 ? 'profile_page_menu_option_active' : ''
                      }`}
                      onClick={() => this.selectMenu(2)}>
                      Share
                    </a>
                  </li>

                  <li>
                    <a
                      className={`${
                        menu == 3 ? 'profile_page_menu_option_active' : ''
                      }`}
                      onClick={() => this.selectMenu(3)}>
                      Results
                    </a>
                  </li>
                </ul>
              </Col>

              <Col
                md={3}
                style={{
                  display: isMobile ? (menu != 3 ? 'flex' : 'none') : 'flex',
                }}
                className="text-center trivi-edit-top-menu-button-grp pl-0">
                {currentTrivia &&
                  currentTrivia.questions &&
                  !isMessagingTrivvy &&
                  currentTrivia.questions.length &&
                  questionsListModal && (
                    <QuestionsListModal
                      open={questionsListModal}
                      onClose={this.closeQuestionsList}
                      currentTrivia={currentTrivia}
                    />
                  )}

                {advanceSettingsModal && currentTrivia && (
                  <AdvanceTrivvySettingModal
                    onlyShowMessagingSettings={isMessagingTrivvy}
                    open={advanceSettingsModal}
                    onClose={() =>
                      this.setState({
                        advanceSettingsModal: false,
                      })
                    }
                    trivia={currentTrivia}
                    setCurrentTrivia={this.props.setCurrentTrivia}
                    saveData={this.callApiToAutoSave}
                    user={this.props.user}
                  />
                )}

                {isMessagingTrivvy ? (
                  <Button
                    onClick={() =>
                      this.setState({ advanceSettingsModal: true })
                    }
                    className="pr-4 mr-3 trivia-edit-btn-height more-actions-bg">
                    {' '}
                    <BsFillGearFill size={18} /> Advanced settings{' '}
                  </Button>
                ) : (
                  <UncontrolledButtonDropdown
                    className="ml-2 mr-2 mb-2"
                    direction={isMobile ? 'up' : 'down'}>
                    <DropdownToggle
                      className="pr-4 trivia-edit-btn-height more-actions-bg"
                      color={'secondary'}
                      size="sm"
                      caret>
                      More actions
                    </DropdownToggle>
                    {isMessagingTrivvy ? (
                      <DropdownMenu style={{ zIndex: '99999999999' }}>
                        <DropdownItem
                          onClick={() =>
                            this.setState({ advanceSettingsModal: true })
                          }>
                          <BsFillGearFill size={18} /> Advanced settings
                        </DropdownItem>
                      </DropdownMenu>
                    ) : (
                      <DropdownMenu style={{ zIndex: '99999999999' }}>
                        <DropdownItem
                          onClick={() => {
                            this.exportConvoPDF()
                          }}>
                          <BsDownload size={18} /> Download
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            this.setState({ advanceSettingsModal: true })
                          }>
                          <BsFillGearFill size={18} /> Advanced Settings
                        </DropdownItem>

                        {currentTrivia &&
                        currentTrivia.isPublished &&
                        currentTrivia.sharedWithUsers &&
                        currentTrivia.sharedWithUsers.length ? (
                          <DropdownItem
                            onClick={() =>
                              this.setState({ manualReminderModal: true })
                            }>
                            <BsAlarmFill size={18} /> Remind Users
                          </DropdownItem>
                        ) : (
                          ''
                        )}

                        <DropdownItem onClick={this.openQuestionsList}>
                          <FaList size={17} /> Questions List
                        </DropdownItem>
                        {planType != '001' && (
                          <DropdownItem
                            onClick={() => this.setState({ linkPopup: true })}>
                            <GiOpenTreasureChest size={18} /> Rewards
                          </DropdownItem>
                        )}

                        <DropdownItem onClick={this.togglePreview}>
                          <BsFillEyeFill size={17} /> Email Preview
                        </DropdownItem>
                      </DropdownMenu>
                    )}
                  </UncontrolledButtonDropdown>
                )}

                {manualReminderModal && (
                  <ManualRemindersModal
                    open={manualReminderModal}
                    triviaData={currentTrivia}
                    onClose={() => {
                      this.setState({
                        manualReminderModal: false,
                      })
                    }}
                  />
                )}

                {isMessagingTrivvy ? (
                  <div>
                    <Button
                      color="success"
                      className="trivia-edit-btn-height mb-2"
                      onClick={this.handleResendSMS}
                      disabled={disabledResendButton()}>
                      Resend <MdOutlineMobileFriendly />
                    </Button>
                  </div>
                ) : (
                  <ButtonDropdown
                    isOpen={buttonDrodownOpen}
                    toggle={this.toggleButtonDropdown}
                    className="ml-3 w-100 trivia-edit-btn-height mb-2"
                    direction={isMobile ? 'up' : 'down'}>
                    <DropdownToggle
                      color={
                        buttonText == 'Published'
                          ? 'success'
                          : buttonText == 'Ended'
                          ? 'danger'
                          : 'secondary'
                      }
                      className="text-center"
                      size="sm"
                      caret
                      disabled={adminRestricted}>
                      {buttonText}
                    </DropdownToggle>
                    <DropdownMenu style={{ zIndex: '99999999999' }}>
                      <DropdownItem
                        onClick={() => {
                          const callBackCode = () => {
                            if (
                              this.props.currentTrivia.scheduledDate &&
                              !this.props.currentTrivia.firstPublishedDate
                            ) {
                              const { currentTrivia } = this.props
                            }
                          }
                          this.publishTriviaApiCall(true, callBackCode)
                        }}
                        disabled={publishDisable}>
                        Publish
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          this.publishTriviaApiCall(false, null)
                          this.showPublishToast()
                        }}
                        disabled={unPublishDisable}>
                        Unpublish
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          const date = moment().startOf('day')

                          this.props.setCurrentTrivia({
                            ...currentTrivia,
                            trivvyEndDate: date,
                          })
                          this.callApiToAutoSave('trivvyEndDate', date)
                        }}
                        disabled={endDisable}>
                        End Trivvy{' '}
                      </DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                )}

                {/* <span
                  data-tip={
                    publishDisabled(currentTrivia)
                      ? "Publish will be disabled until you set correct option for all questions"
                      : "Publish"
                  }
                >
                  <Button
                    size="sm"
                    // color={surveyItem.isPublished ? "":"success"}
                    color={surveyItem.isPublished ? "success" : "secondary"}
                    className={`ml-2 trivia-edit-menu-publish-btn  ${
                      surveyItem.isPublished
                        ? "trivvy-btn-published"
                        : "trivvy-btn-not-published"
                    }`}
                    disabled={publishDisabled(currentTrivia)}
                    // surveyItem.isPublished ? outline: ''
                    // outline
                    onClick={() => {
                      // if(!surveyItem.isPublished){
                      this.callApiToAutoSave(
                        "isPublished",
                        !surveyItem.isPublished
                      );
                      this.props.setCurrentTrivia({
                        ...this.props.currentTrivia,
                        isPublished: !surveyItem.isPublished,
                      });
                      // }else{

                      // }
                    }}
                  >
                    {surveyItem.isPublished ? "Published" : "Publish ?"}
                  </Button>
                </span> */}

                <ReactTooltip />
              </Col>
            </Row>
          )}

          {surveyItem && this.props.currentTrivia && (
            <div
              className={isMobile ? 'px-2' : 'handle-less-width-main-edit'}
              style={{
                position: 'relative',
                top: isMobile ? '62px' : '65px',
              }}>
              {menu === 1 ? (
                <TriviaEditViewListUI
                  showPopupModal={() => this.setState({ linkPopup: true })}
                  linkedRewards={linkedRewards}
                  setAdvanceSettingModal={(val) => {
                    this.setState({ advanceSettingsModal: val })
                  }}
                  planType={planType}
                  publishTriviaApiCall={this.publishTriviaApiCall}
                  {...this.props}
                />
              ) : menu === 2 ? (
                <NewShareTriviaComponent
                  user={this.props.user}
                  surveyId={this.props.currentTrivia._id}
                  // setCurrentQuestion={this.props.setCurrentQuestion}
                  survey={this.props.currentTrivia}
                  editCurrentTriviaShareData={
                    this.props.editCurrentTriviaShareData
                  }
                  setCurrentTrivia={this.props.setCurrentTrivia}
                  callApiToAutoSave={this.callApiToAutoSave}
                  publishTriviaApiCall={this.publishTriviaApiCall}
                  showPublishToast={this.showPublishToast}
                  {...this.props}
                />
              ) : (
                <TriviaResultsComponent
                  currentTrivia={this.props.currentTrivia}
                  setCurrentTrivia={this.props.setCurrentTrivia}
                  {...this.props}
                />
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    currentTrivia: state.trivia.currentTrivia,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    setCurrentQuiz: (data) => dispatch(actionCreators.setCurrentQuiz(null)),
    setCurrentQuestion: (data) =>
      dispatch(actionCreators.setCurrentQuestion(null)),
    resetTrivia: (data) => dispatch(actionCreators.resetTrivia(data)),
    editCurrentTriviaShareData: (data) =>
      dispatch(actionCreators.editCurrentTriviaShareData(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaEdit, axios))
